import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import PageElementTypeEnum from 'enums/page_element_type.enum';
import ElementActions from 'pages/admin/common/page-elements/types/ElementActions';
import TextEditor from 'components/TextEditor';
import { Checkbox } from 'antd';

const TextElement = React.memo(({ id, pageElement, setPageElement, setRefs }) => {
    const { t } = useTranslation();
    return (
        <div className="page-element-block">
            <div className="header pb-24">
                <div className="element-common-heading">{t(`enum:${PageElementTypeEnum.TEXT.text}`)}</div>
                <ElementActions id={id} />
            </div>
            <div className="element-item">
                <TextEditor
                    value={pageElement.content}
                    setValue={v => {
                        setPageElement({ id, changes: { content: v } });
                    }}
                    id={id}
                    setRefs={setRefs}
                />
            </div>
            <div>
                <Checkbox
                    className="mt-24"
                    checked={pageElement.is_displayed}
                    onChange={e => {
                        setPageElement({ id, changes: { is_displayed: e.target.checked ? 1 : 0 }});
                    }}
                >
                    {t('Posted in the news')}
                </Checkbox>
            </div>
        </div>
    );
});

export default TextElement;

TextElement.propTypes = {
    id: PropTypes.any.isRequired,
    pageElement: PropTypes.object,
    setPageElement: PropTypes.func,
};
